export { default } from './CarRegistration';